const data = [
  {
    id: 1,
    text: "bikes",
    btn: "fullSizeMenu",
    size: "fullSize",
    pathTo: "/hardtail",
  },
  {
    id: 2,
    text: "gear",
    btn: "fullSizeMenu",
    size: "fullSize",
    pathTo: "/",
  },
  {
    id: 3,
    text: "support",
    btn: "fullSizeMenu",
    size: "fullSize",
    pathTo: "/",
  },
  {
    id: 4,
    text: "retailers",
    btn: "fullSizeMenu",
    size: "fullSize",
    pathTo: "/",
  },
  {
    id: 5,
    text: "sale",
    btn: "fullSizeMenu",
    size: "fullSize",
    pathTo: "/",
  },
  {
    id: 6,
    text: "search",
    btn: "mobile",
    size: "mobile",
    pathTo: "/",
  },
  {
    id: 7,
    text: "my account",
    btn: "mobile",
    size: "mobile",
    pathTo: "/",
  },
  {
    id: 8,
    text: "select your location",
    size: "mobile",
    pathTo: "/",
  },
]

export default data
